import React, { SetStateAction, useMemo } from "react";
import {
  Box,
  Text,
  Button,
  FormControl,
  FormLabel,
  Checkbox,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { InternationalPhoneInput } from "components/InternationalPhoneInput/InternationalPhoneInput";

interface PhoneVerificationFormProps {
  phoneData: { phone?: string; code?: string };
  setPhoneData: React.Dispatch<
    React.SetStateAction<{ phone?: string; code?: string }>
  >;
  onConfirm: () => void;
  isLoading: boolean;
  title?: string;
  description?: string;
  confirmButtonText?: string;
  isPhoneAlreadyUsed: boolean;
  consentChecked: boolean;
  setConsentChecked: (value: SetStateAction<boolean>) => void;
  isPhoneAlreadyVerified?: boolean;
}

export const PhoneVerificationForm: React.FC<PhoneVerificationFormProps> = ({
  phoneData,
  setPhoneData,
  onConfirm,
  isLoading,
  title,
  description,
  confirmButtonText,
  isPhoneAlreadyUsed,
  consentChecked,
  setConsentChecked,
  isPhoneAlreadyVerified,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "admin.myData",
  });

  const isConfirmDisabled = useMemo(() => {
    return !phoneData.phone || !consentChecked;
  }, [phoneData.phone, consentChecked]);

  return (
    <Box display={"flex"} flexDir="column" pt="24px" gap="24px">
      <Text fontSize="lg">{title}</Text>
      <Text fontSize="sm">{description}</Text>

      <Box>
        <FormControl isRequired>
          <FormLabel fontSize={"sm"} fontWeight="normal">
            {t("phone")}
          </FormLabel>
        </FormControl>
        <InternationalPhoneInput
          style={{ width: "100%" }}
          phoneData={phoneData}
          setPhoneData={setPhoneData}
        />

        {isPhoneAlreadyUsed && (
          <Text fontSize={"xs"} color="red.400" mt={1}>
            {t("phoneAlreadyInUse")}
          </Text>
        )}
      </Box>

      <Checkbox
        isChecked={consentChecked}
        onChange={(e) => setConsentChecked(e.target.checked)}
      >
        <Text fontSize="xs">{t("iAgreeReceive")}</Text>
      </Checkbox>

      <Button
        layerStyle="ocean"
        _hover={{ layerStyle: "ocean" }}
        onClick={onConfirm}
        w="100%"
        isDisabled={isConfirmDisabled || isLoading || isPhoneAlreadyVerified}
        isLoading={isLoading}
      >
        {isPhoneAlreadyVerified
          ? t("alreadyVerifiedNumber")
          : confirmButtonText}
      </Button>
    </Box>
  );
};
